import { EntityHeadingDeg } from "./consts"
import type { EntityHeadingMeta } from "./EntityHeadingMeta.type"

const entityHeadingsMetaList : Array<EntityHeadingMeta> = [
  { value: EntityHeadingDeg.North,
    dname: 'North', abbr: 'N' },
  { value: EntityHeadingDeg.East,
    dname: 'East', abbr: 'E' },
  { value: EntityHeadingDeg.South,
    dname: 'South', abbr: 'S' },
  { value: EntityHeadingDeg.West,
    dname: 'West', abbr: 'W' },
]

export default entityHeadingsMetaList